// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yjndwdndlhusqgpudkid.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlqbmR3ZG5kbGh1c3FncHVka2lkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE2MTk1OTYsImV4cCI6MjA2NzE5NTU5Nn0.5-qMBhcFWPAHGoKup5JuI2IsnNiGpz-zTY-kTowKIwE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});